import React from 'react';
import toolboxDetailSubNav from 'components/Page/Toolbox/data/toolboxDetailSubNav';
import { Container } from './styles';
import useToolboxContentHub from 'hooks/useToolboxContentHub';
import FeaturedContent from './FeaturedContent';
import ResourceSwitch from './ResourceSwitch';
import { SectionLayout } from 'components/Sections/SectionLayout';
import Header from './Header';

const ToolboxSection = props => {
  const toolboxNavData = toolboxDetailSubNav();
  const toolboxContentHubData = useToolboxContentHub();
  const featuredContent = toolboxContentHubData.contentfulContentHub.featuredContent[0];

  return (
    <SectionLayout backgroundColor="Gray 1">
      <Container>
        <Header logo={toolboxNavData.logo} />
        <FeaturedContent feature={featuredContent} />
        <ResourceSwitch data={toolboxContentHubData} radio={toolboxNavData.navigation} />
      </Container>
    </SectionLayout>
  );
};

export default ToolboxSection;
